<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <el-row>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <!-- logo -->
        <div class="logo">
          <img
            v-if="bannerArr.length > 0"
            :src="$imgUrl + bannerArr[0].thumb"
            alt=""
          />
        </div>
        <!-- 内容区 -->
        <div class="container">
          <div class="exh_top_list">
            <div
              :class="['exh_top_item', item.path ? 'cursor': '' ]"
              v-for="(item, index) in processLists"
              :key="index"
              @click="toLink(item.path)"
            >
              <div class="exh_procedure">
                <span>{{ index + 1 }}</span>
                <span>{{ langSet == "cn" ? item.title : item.en_title }}</span>
              </div>
              <div class="exh_procedure_content">
                <div
                  v-html="langSet == 'cn' ? item.content : item.en_content"
                ></div>
              </div>
            </div>
            <!-- <div class="exh_top_item">
                <div class="exh_procedure">
                  <span>2</span>
                  <span>填写参展申请表</span>
                </div>
                <div class="exh_procedure_content">
                 <div>主办方收到《参展申请表》审核通过后，联系参展商选取展位确定价格</div>
                </div>
              </div>
              <div class="exh_top_item">
                <div class="exh_procedure">
                  <span>3</span>
                  <span>签订参展协议并付款</span>
                </div>
                <div class="exh_procedure_content">
                 <div>双方签订协议，完成付款</div><br>
                 <div>优惠期截止：</div>
                 <div>2025年2月28日前</div><br>
                 <div>展位费50%首付款 </div>
                 <div>缴纳时间：签订参展协议后30个工作日内</div><br>
                </div>
              </div>
              <div class="exh_top_item">
                <div class="exh_procedure">
                  <span>4</span>
                  <span>购买展会增值服务</span>
                </div>
                <div class="exh_procedure_content">
                  <div>增值服务：会议室预定、现场广告、互联网广告、印刷品广告</div><br>
                  <div>电话：</div>
                  <div>010-68512208</div><br>

                 <div>邮箱：</div>
                 <div>expo@bceia.cn</div>
                </div>
              </div>
              <div class="exh_top_item">
                <div class="exh_procedure">
                  <span>5</span>
                  <span>提交展前相关资料</span>
                </div>
                <div class="exh_procedure_content">
                  <div>楣板字及会刊信息：2025年开展前1个月</div><br>
                  <div>参展产品信息：</div>
                  <div>2025年开展前1个月</div><br>

                 <div>展商胸卡信息：</div>
                 <div>2025年开展前1个月</div>
                </div>
              </div> -->
          </div>
          <div class="schedule_box">
            <div class="h2-title">
              {{ langSet == "cn" ? "展览会日程安排" : "Exhibition Schedule" }}
            </div>
            <div v-if="!tableShow">

              <div class="noData">敬请期待</div>
            </div>
            <div v-else>
              <table class="fir_table">
                <thead>
                <tr>
                  <td
                      v-for="(item, index) in langSet == 'cn'
                      ? exhibition_start.table_head
                      : exhibition_start.en_table_head"
                      :key="index"
                  >
                    {{ item }}
                  </td>
                  <!-- <td>展馆</td>
                      <td>开始时间</td>
                      <td>结束时间</td> -->
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(item, index) in langSet == 'cn'
                    ? exhibition_start.dataList
                    : exhibition_start.en_dataList"
                    :key="index"
                >
                  <td>{{ item.title }}</td>
                  <td>{{ item.hallNo }}</td>
                  <td>{{ item.start_time }}</td>
                  <td>{{ item.end_time }}</td>
                </tr>
                </tbody>
              </table>
              <table class="sce_table">
                <thead>
                <tr>
                  <td
                      v-for="(item, index) in langSet == 'cn'
                      ? exhibition_load.table_head
                      : exhibition_load.en_table_head"
                      :key="index"
                  >
                    {{ item }}
                  </td>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(item, index) in langSet == 'cn'
                    ? exhibition_load.dataList
                    : exhibition_load.en_dataList"
                    :key="index"
                >
                  <td>{{ item.title }}</td>
                  <td>{{ item.entry_time }}</td>
                  <td>{{ item.show_time }}</td>
                  <td>{{ item.close_time }}</td>
                </tr>
                </tbody>
              </table>
              <table>
                <thead>
                <tr>
                  <td
                      v-for="(item, index) in langSet == 'cn'
                      ? exhibition_end.table_head
                      : exhibition_end.en_table_head"
                      :key="index"
                  >
                    {{ item }}
                  </td>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(item, index) in langSet == 'cn'
                    ? exhibition_end.dataList
                    : exhibition_end.en_dataList"
                    :key="index"
                >
                  <td>{{ item.title }}</td>
                  <td>{{ item.start_time }}</td>
                  <td>{{ item.end_time }}</td>
                </tr>
                </tbody>
              </table>
              <div class="table_tips">
                <div
                    v-html="langSet == 'cn' ? notice.notice : notice.en_notice"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import bottom from "../../components/bottom.vue";
import { getBanner, getProcessLists, getcalendarLists } from "@/api/api";
import fa from "element-ui/src/locale/lang/fa";
export default {
  components: { top, bottom },
  name: "exhibitionProcess",
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.langSet == "cn" ? this.keydata.name_cn : this.keydata.name_en,
      meta: [
        {
          name: "description",
          content: this.keydata.description,
        },
        {
          name: "keywords",
          content: this.keydata.keywords,
        },
      ],
    };
  },
  data() {
    return {
      langSet: "",
      bannerArr: [],
      processLists: [],
      exhibition_end: {},
      exhibition_start: {},
      exhibition_load: {},
      notice: {},
      keydata: {},
      tableShow:false
    };
  },
  created() {},
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    console.log(menuArr, "menuArr");
    menuArr.map((item) => {
      if (item.children) {
        item.children.map((i) => {
          if (i.name_cn == "参展流程" || i.name_en == "Exhibition process") {
            this.keydata = i;
          }
        });
      }
    });
  },
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "cn";
    this.getBannerList();
    this.getProcessLists();
    this.getcalendarLists();
  },
  methods: {
    // zhang 获取展会服务banner
    getBannerList() {
      let data = {
        class: "参展流程",
        lang_type: this.langSet,
      };
      getBanner(data)
        .then((res) => {
          if (res.code == 1) {
            this.bannerArr = res.data.lists;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // zhang 参展流程
    getProcessLists() {
      let data = {};
      getProcessLists(data)
        .then((res) => {
          if (res.code == 1) {
            this.processLists = res.data.lists;
            this.processLists[1].path = 'apply';
            console.log(this.processLists, '====this.processLists')
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getcalendarLists() {
      let data = {};
      getcalendarLists(data)
        .then((res) => {
          if (res.code == 1) {
            if(res.data.length==0){
              this.tableShow=false
            }else {
              this.exhibition_end = res.data.exhibition_end;
              this.exhibition_start = res.data.exhibition_start;
              this.exhibition_load = res.data.exhibition_load;
              debugger
              this.notice = res.data.notice;
              this.tableShow=true
            }

          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toLink(path){
      if (path) {
        this.$router.push({
          name: path,
        });
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.logo {
  width: 100%;
  height: 400px;
  img {
    width: 100%;
    height: 400px;
  }
}
.container {
  // width: 1280px;
  margin: 0 auto;
  padding: 50px 0 170px;
  box-sizing: border-box;
  .h2-title {
    font-size: 18px !important;
    font-weight: 500 !important;
  }

  tr {
    height: 68px;
    line-height: 68px;
  }
  .schedule_box {
    margin-top: 80px;
    .fir_table {
      margin: 50px 0 80px;
    }
    .sce_table {
      margin-bottom: 80px;
    }
    .table_tips {
      width: 1280px;
      padding: 25px 84px 32px;
      box-sizing: border-box;
      background: rgba(255, 77, 79, 0.05);
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #ff4d4f;
      line-height: 20px;
    }
  }
  .exh_top_list {
    display: flex;
    justify-content: space-between;
  }
  .cursor{
    cursor: pointer;
    &:hover .exh_procedure_content{
      color: #243889;
    }
  }
  .exh_top_item {
    width: -webkit-calc((100% - 20px * 5)/ 5);
    width: calc((100% - 20px * 5) / 5);
    background: #ffffff;
    margin: 0 20px 0 0;
    &:last-child {
      margin-right: 0;
    }
    .exh_procedure {
      display: flex;
      // justify-content: center;
      align-items: center;
      width: 100%;
      height: 68px;
      background: #243889;
      padding-left: 15px;
      box-sizing: border-box;
      border-radius: 15px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 22px;
      color: #ffffff;
      span:nth-child(1) {
        display: inline-block;
        width: 22px;
        height: 22px;
        line-height: 22px;
        text-align: center;
        background: #fff;
        border-radius: 50%;
        color: #243889;
        margin-right: 10px;
      }
      span:nth-child(2) {
        display: inline-block;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #ffffff;
      }
    }
    .exh_procedure_content {
      width: 100%;
      padding: 30px 20px;
      box-sizing: border-box;
      background: rgba(171, 181, 205, 0.1);
      border-radius: 15px;
      height: 300px;
      margin-top: 10px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #2c2c2e;
      line-height: 20px;
    }
  }
}
table {
  width: 100%;
  background-color: #fff;
  border-radius: 15px 15px 0px 0px;
  text-align: center;
  overflow: hidden;
}
thead {
  width: 1280px;
  height: 68px;
  line-height: 68px;
  background: #243889;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
}

tbody {
  width: 1280px;
  height: 68px;
  font-size: 14px;
  line-height: 68px;
  tr:nth-child(odd) {
    background: rgba(171, 181, 205, 0.02);
  }
  tr:nth-child(even) {
    background: rgba(171, 181, 205, 0.1);
  }
}
@media only screen and (max-width: 1280px) {
  .container .schedule_box .table_tips {
    width: 100%;
  }
  .container .exh_top_item .exh_procedure span:nth-child(2) {
    font-size: 14px;
  }
  .container .exh_top_item .exh_procedure_content {
    font-size: 13px;
    padding: 15px 20px;
  }
}
@media only screen and (max-width: 1000px) {
  .container {
    .exh_top_list {
      flex-wrap: wrap;
    }
    .exh_top_item {
      width: 100%;
      margin: 0 0 20px 0;
      .exh_procedure_content {
        height: auto;
        font-size: 14px;
      }
    }
  }
}
@media only screen and (max-width: 767px) {
  .container {
    width: 90% !important;
    padding: 47px 0 50px !important;
    .exh_top_list {
      flex-wrap: wrap;
      .exh_top_item {
        width: 100% !important;
        margin: 0 0 20px !important;
        .exh_procedure {
          height: 50px !important;
          justify-content: flex-start !important;
          padding-left: 15px !important;
          box-sizing: border-box !important;
          font-size: 16px !important;
          border-radius: 8px !important;
        }
        .exh_procedure_content {
          font-size: 15px !important;
          height: auto !important;
          padding: 20px 15px !important;
          margin-top: 5px !important;
        }
      }
    }

    .schedule_box {
      width: 100% !important;
      margin-top: 50px !important;
      .fir_table {
        width: 100% !important;
        margin-bottom: 20px !important;
        margin-top: 20px !important;
        td {
          width: 24% !important;
        }
        td:nth-child(1) {
          width: 28% !important;
        }
      }
      .sce_table {
        width: 100% !important;
        margin-bottom: 20px !important;
        td {
          width: 24% !important;
        }
        td:nth-child(1) {
          width: 28% !important;
        }
      }
      .table_tips {
        width: 100% !important;
        font-size: 12px !important;
        padding: 10px !important;
      }
    }
  }
  thead {
    font-size: 12px !important;
    line-height: initial !important;
  }
  tbody {
    font-size: 13px !important;
    line-height: initial !important;
  }
  tr {
    display: flex;
    height: 68px;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px !important;
    line-height: initial !important;
    td {
      width: 25% !important;
    }
    td:nth-child(1) {
      width: 50% !important;
    }
  }
  .logo {
    width: 100%;
    height: 122px;
    img {
      width: 100%;
      height: 122px;
    }
  }
}
.noData{
  width: 100%;
  height: 100px;
  background: #243889;
  color: #ffffff;
  text-align: center;
  line-height: 100px;
  border-radius: 20px;
  font-size: 18px;
  margin: 40px 0;
}
</style>